const BreakFree = () => (
    <section id="break-free">
        <div className="container-fluid py-4 text-center">
            <div className="row align-items-center justify-content-center">
                <div className="col-xxl-7 col-md-9 col-11">
                    <h4 className="fw-bold mb-4">She knew I could be the next type 2 diabetic to break free.</h4>
                    <p>I called and managed to schedule an appointment.</p>
                    <p>
                        He wasn’t some big pharma name or flashy health guru.<br />
                        In fact, I first met him in the back room of a community centre, tucked between dusty boxes of brochures and folding chairs.<br />
                        Not exactly the setting for a life-altering encounter.
                    </p>
                    <p>
                        But something about him felt different.<br />
                        Measured. Calm.<br />
                        Like he already knew what I was going to say before I said it.
                    </p>
                    <p>
                        He didn’t give me a speech.<br />
                        No "life hacks."<br />
                        No miracle claims.
                    </p>
                    <p>
                        What he offered instead was proof - quiet, solid proof - that managing type 2 diabetes didn’t have to mean a lifetime of restriction, needles, and fear.<br />
                        Not some theoretical possibility buried in lab studies or behind paywalls, but something <i>real</i>, something <i>human</i>.
                    </p>
                    <p>
                        Dr. Hart had spent years studying what others overlooked.<br />
                        He believed the body didn’t need force. It needed understanding.<br />
                        And that true change happens when you support the root, not suppress the symptoms.
                    </p>
                    <p>
                        I didn’t fully understand what that meant yet…<br />
                        But I knew enough to keep listening.
                    </p>
                </div>
            </div>
        </div>
    </section>
);

export default BreakFree;